import React, { useEffect, useState } from 'react';
import { ref, get } from "firebase/database";
import { database } from '../utils/firebase';
import { quotesList } from '../data/quotes';

const Header = ({ about, work, education, contact }) => {
  const scrollHandler = (elementRef) => {
    window.scrollTo({ top: elementRef.current.offsetTop, behavior: "smooth" });
  }
  const [scrollPosition, setScrollPosition] = useState(0);

  useEffect(() => {
    let ticking = false;
    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          setScrollPosition(window.scrollY);
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  let colorAbout, colorWork, colorEducation, colorContact;


  const colorWhite = "#ffffff", colorGray = "#718096";
  colorAbout = colorWhite; colorWork = colorGray; colorEducation = colorGray; colorContact = colorGray;
  if (scrollPosition > 3500) {
    colorAbout = colorGray; colorWork = colorGray; colorEducation = colorGray; colorContact = colorWhite;
  }
  else if (scrollPosition > 2800) {
    colorAbout = colorGray; colorWork = colorGray; colorEducation = colorWhite; colorContact = colorGray;
  }
  else if (scrollPosition > 500) {
    colorAbout = colorGray; colorWork = colorWhite; colorEducation = colorGray; colorContact = colorGray;
  }


  // Fetch all messages from the "messages" node in Firebase Realtime Database
  const getMessages = async () => {
    try {
      await new Promise(resolve => setTimeout(resolve, 200));
      const messagesRef = ref(database, 'messages');
      const snapshot = await get(messagesRef);
      if (snapshot.exists()) {
        // Returns an array of messages with their keys
        return Object.entries(snapshot.val())
          .reverse()
          .map(([id, data]) => ({ id, ...data }));
      } else {
        return [];
      }
    } catch (error) {
      console.error("Error fetching messages:", error);
      throw error;
    }
  }

  const [menuOpen, setMenuOpen] = useState(false);

  const [messages, setMessages] = useState(null);
  const [showMessages, setShowMessages] = useState(false);
  const [showThought, setShowThought] = useState(false);
  const [dailyQuote, setDailyQuote] = useState("");

  useEffect(() => {
    if (showThought) {
      setDailyQuote(quotesList[Math.floor(Math.random() * quotesList.length)]);
    }
  }, [showThought]);

  // Fetch messages when bell icon is clicked
  const handleBellClick = async (e) => {
    e.stopPropagation();
    try {
      setShowMessages(true);
      const msgs = await getMessages();
      setMessages(msgs);
    } catch (error) {
      setMessages([]);
      setShowMessages(true);
    }
  };

  return (
    <>
      <div className="fixed top-0 left-0 w-full z-20 font-nunito">
        {/* Background layer */}
        <div className="absolute inset-0 bg-gray-900 bg-opacity-95 pointer-events-none"></div>
        <div className="relative flex flex-col md:flex-row justify-between shadow-lg w-full max-w-full h-[72px] md:h-[72px]">
          <div
            className="pl-3 pr-10 md:pl-12 md:pr-12 py-3 md:py-0 flex items-center justify-start h-full"
            onClick={() => scrollHandler(about)}
          >
            <h1 className="relative px-1 py-1 m-1 font-bold text-[#61dafb] text-2xl cursor-pointer whitespace-nowrap">
              Krishnendu Addya
            </h1>
            <div className="ml-0 md:ml-5 flex items-center z-30 space-x-3 md:space-x-6" style={{ position: "relative" }}>
              <button
                className="relative focus:outline-none"
                aria-label="Notifications"
                onClick={handleBellClick}
              >
                {/* Bell SVG */}
                <svg
                  className="w-8 h-8 text-white hover:text-violet-500 transition-colors duration-300"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
                  />
                </svg>
                {/* Red notification badge */}
                <span
                  className={`absolute -top-1 -right-1 bg-red-600 rounded-full w-5 h-5 flex items-center justify-center font-bold text-white border-2 border-white
                    ${messages?.length?.toString().length >= 2 ? 'text-[0.60rem]' : 'text-[0.70rem]'}
                  `}
                >
                  {messages?.length > 0 ? messages?.length : 5}
                </span>
              </button>

              {/* Thought of the Day Section */}
              <button
                className="relative focus:outline-none"
                aria-label="Thought of the Moment"
                onClick={(e) => { e.stopPropagation(); setShowThought(true); }}
              >
                <svg
                  className="w-9 h-9 text-white hover:text-violet-500 transition-colors duration-300"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09z" />
                </svg>
              </button>

            </div>
          </div>

          {/* Desktop menu */}
          <div className="hidden md:flex relative mr-12 md:justify-end justify-center items-center h-full">
            <h1
              className="px-6 py-2 mx-auto md:mx-0 font-bold text-lg cursor-pointer nav-link"
              style={{ color: colorAbout }}
              onClick={() => scrollHandler(about)}
            >
              About
            </h1>
            <h1
              className="px-6 py-2 mx-auto md:mx-0 font-bold text-lg cursor-pointer nav-link"
              style={{ color: colorWork }}
              onClick={() => scrollHandler(work)}
            >
              Work
            </h1>
            <h1
              className="px-6 py-2 mx-auto md:mx-0 font-bold text-lg cursor-pointer nav-link"
              style={{ color: colorEducation }}
              onClick={() => scrollHandler(education)}
            >
              Education
            </h1>
            <h1
              className="px-6 py-2 mx-auto md:mx-0 font-bold text-lg cursor-pointer nav-link"
              style={{ color: colorContact }}
              onClick={() => scrollHandler(contact)}
            >
              Contact
            </h1>
          </div>
          {/* Hamburger menu for small screens - moved to right */}
          <div className="md:hidden flex items-center absolute right-0 top-0 h-[72px] mr-6 z-20">
            <button
              onClick={() => setMenuOpen(!menuOpen)}
              className="focus:outline-none"
              aria-label="Toggle menu"
            >
              <svg
                className="w-9 h-9 text-white"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                {menuOpen ? (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                ) : (
                  <>
                    {/* Top line (full width) */}
                    <line x1="4" y1="6" x2="20" y2="6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                    {/* Middle line (shorter width) */}
                    <line x1="7" y1="12" x2="20" y2="12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                    {/* Bottom line (full width) */}
                    <line x1="4" y1="18" x2="20" y2="18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                  </>
                )}
              </svg>
            </button>
          </div>
          {/* Mobile menu with animated staggered items */}
          {menuOpen && (
            <AnimatedMobileMenu
              colorAbout={colorAbout}
              colorWork={colorWork}
              colorEducation={colorEducation}
              colorContact={colorContact}
              scrollHandler={scrollHandler}
              about={about}
              work={work}
              education={education}
              contact={contact}
              setMenuOpen={setMenuOpen}
            />
          )}

          {/* Popups moved to root for correct positioning and background blur */}
          {showMessages && (
            <>
              <div
                className="fixed inset-0 z-[60] bg-black bg-opacity-40 backdrop-blur-[1px]"
                onClick={(e) => { e.stopPropagation(); setShowMessages(false); }}
              ></div>
              <div
                className={`
                  fixed z-[70]
                  ${window.innerWidth < 640
                    ? 'left-1/2 top-16 -translate-x-1/2'
                    : 'left-[120px] top-[70px]'}
                `}
              >
                <div
                  className="bg-[#101a2b] shadow-2xl rounded-lg w-80 p-4 relative overflow-hidden border-2 border-[#1f223c]"
                  style={{
                    boxShadow: '0 12px 48px 0 rgba(139, 92, 246, 0.45), 0 4px 12px 0 #0a1931',
                    background: 'linear-gradient(135deg, #101a2b 80%, #22335a 100%)'
                  }}
                >
                  <div
                    className="absolute inset-0 pointer-events-none"
                    style={{
                      background: 'radial-gradient(circle at 70% 30%, rgba(34,51,90,0.7) 0%, rgba(16,26,43,0.95) 20%)',
                      zIndex: 1
                    }}
                  />
                  <img
                    className="absolute inset-0 w-full h-full object-cover opacity-10 pointer-events-none"
                    src="assets/contact-bg-full.jpg"
                    alt="contact-bg"
                    style={{ filter: 'blur(2px)', zIndex: 0 }}
                  />
                  <div className="absolute top-2 right-2 z-20">
                    <button
                      className="text-gray-300 hover:text-white focus:outline-none"
                      onClick={(e) => { e.stopPropagation(); setShowMessages(false); }}
                      aria-label="Close messages"
                    >
                      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                      </svg>
                    </button>
                  </div>
                  <h2 className="text-lg font-bold pb-2 mb-4 text-white relative z-10 text-center border-b border-white border-opacity-20">Messages</h2>
                  {messages === null ? (
                    <div className="space-y-2 max-h-64 overflow-y-auto relative z-10">
                      {[1, 2, 3, 4, 5].map(i => (
                        <div key={i} className="animate-pulse flex flex-col space-y-2 pb-2 border-b border-gray-600">
                          <div className="h-4 w-1/3 bg-gray-700 rounded"></div>
                          <div className="h-3 w-3/4 bg-gray-800 rounded"></div>
                        </div>
                      ))}
                    </div>
                  ) : messages.length === 0 ? (
                    <div className="text-gray-300 relative z-10">No messages found.</div>
                  ) : (
                    <div className="space-y-2 max-h-64 overflow-y-auto relative z-10">
                      {messages.map(msg => (
                        <div key={msg.id} className="border-b border-gray-600 pb-2">
                          <div className="font-bold text-base">{msg.name || "Anonymous"}</div>
                          <div className="text-gray-200 text-base">{msg.message}</div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </>
          )}

          {showThought && (
            <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black bg-opacity-40 backdrop-blur-[1px]" onClick={(e) => { e.stopPropagation(); setShowThought(false); }}>
              <div
                className="bg-[#101a2b] shadow-2xl shadow-violet-500/20 rounded-lg w-10/12 max-w-[340px] sm:max-w-lg p-6 sm:p-8 relative overflow-hidden min-h-[350px] sm:min-h-[250px] flex flex-col border-2 border-[#1f223c]"
                onClick={(e) => e.stopPropagation()}
                style={{
                  boxShadow: '0 12px 48px 0 rgba(139, 92, 246, 0.45), 0 4px 12px 0 #0a1931',
                  background: 'linear-gradient(135deg, #101a2b 80%, #22335a 100%)'
                }}
              >
                <div
                  className="absolute inset-0 pointer-events-none"
                  style={{
                    background: 'radial-gradient(circle at 70% 30%, rgba(34,51,90,0.7) 0%, rgba(16,26,43,0.95) 20%)',
                    zIndex: 1
                  }}
                />
                <img
                  className="absolute inset-0 w-full h-full object-cover opacity-10 pointer-events-none"
                  src="assets/contact-bg-full.jpg"
                  alt="contact-bg"
                  style={{ filter: 'blur(2px)', zIndex: 0 }}
                />
                <div className="absolute top-4 right-4 z-20">
                  <button
                    className="text-gray-300 hover:text-white focus:outline-none"
                    onClick={(e) => { e.stopPropagation(); setShowThought(false); }}
                    aria-label="Close thought"
                  >
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
                  </button>
                </div>
                <h2 className="text-lg font-bold text-white relative z-10 text-center border-b border-white border-opacity-20 pb-4 mb-6 tracking-wide">
                  Thought of the Moment
                </h2>
                <div className="relative z-10 flex-1 flex flex-col justify-center items-center text-center px-4">
                  <div className="mb-6 flex justify-center">
                    <svg className="w-12 h-12 text-violet-500 opacity-90" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="1.5">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09z" />
                    </svg>
                  </div>
                  <p className="text-gray-200 italic font-bold text-xl sm:text-2xl leading-relaxed pb-8">
                    "{dailyQuote}"
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

// AnimatedMobileMenu component for staggered animation
const AnimatedMobileMenu = ({
  colorAbout,
  colorWork,
  colorEducation,
  colorContact,
  scrollHandler,
  about,
  work,
  education,
  contact,
  setMenuOpen
}) => {
  const [showItems, setShowItems] = useState([false, false, false, false]);

  useEffect(() => {
    let timers = [];
    setShowItems([false, false, false, false]);
    timers = [
      setTimeout(() => setShowItems(items => [true, false, false, false]), 50),
      setTimeout(() => setShowItems(items => [true, true, false, false]), 150),
      setTimeout(() => setShowItems(items => [true, true, true, false]), 250),
      setTimeout(() => setShowItems(items => [true, true, true, true]), 350),
    ];
    return () => timers.forEach(t => clearTimeout(t));
  }, []);

  const menuItems = [
    { label: "About", color: colorAbout, ref: about },
    { label: "Work", color: colorWork, ref: work },
    { label: "Education", color: colorEducation, ref: education },
    { label: "Contact", color: colorContact, ref: contact },
  ];

  return (
    <div className="md:hidden fixed top-[72px] left-0 w-full bg-gray-900 bg-opacity-95 flex flex-col items-center py-4 z-10">
      {menuItems.map((item, idx) => (
        <h1
          key={item.label}
          className={`
            px-6 py-2 font-bold text-lg cursor-pointer text-white
            transition-all duration-300
            ${showItems[idx] ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-4'}
          `}
          style={{
            color: item.color,
            transitionDelay: `${idx * 10}ms`
          }}
          onClick={() => {
            scrollHandler(item.ref);
            setMenuOpen(false);
          }}
        >
          {item.label}
        </h1>
      ))}
    </div>
  );
};

export default Header;